import { Col, Row } from "components/BaseComponents/Flex";
import Switch from "components/BaseComponents/Switch";
import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { IAgentAuthListItem } from "models/Employee/employeeManagement.model";
import { Control } from "react-hook-form";
import {
  StyledEmpDescription,
  StyledEmpLabel,
  StyledEmpOuterContainer,
  StyledEmpTextWrapper,
  StyledEmpValueContainer,
} from "../EmployeePanel/EmployeeDetail.styles";
import { Typography } from "components";
import { TFunction } from "i18next";

interface AuthListItemProps {
  control?: Control<any>;
  agentAuthList: IAgentAuthListItem[];
  onAuthChange?: any;
  isAuthCheck?: boolean;
  isDetail: boolean;
  t?: TFunction;
}

const AuthListItem = ({
  control,
  agentAuthList,
  isAuthCheck,
  onAuthChange,
  isDetail,
  t,
}: AuthListItemProps): JSX.Element[] => {
  return agentAuthList.map((auth: IAgentAuthListItem, index: number) => (
    <Row
      key={`${index}_${auth.OrderNo}`}
      backgroundColor={DIGIPOSTHEME.colors.whiteGrey}
      justifyContent='flex-start'
      isResponsive
      padding='0 0 20px 0'
    >
      {!isDetail ? (
        <Col>
          <Switch
            key={`${auth.OrderNo}_${index}`}
            control={control!}
            color={DIGIPOSTHEME.colors.primaryAkbankRed}
            justifyContent='space-between'
            name={auth.Type}
            label={auth.Title}
            description={auth.Description}
            isToggle={auth.Value ?? isAuthCheck}
            onChange={onAuthChange}
            disabled={auth.Type.toLowerCase() === "payment"}
          />
        </Col>
      ) : (
        <StyledEmpOuterContainer>
          <StyledEmpTextWrapper>
            <StyledEmpLabel>{auth.Title}</StyledEmpLabel>
            <StyledEmpDescription>{auth.Description}</StyledEmpDescription>
          </StyledEmpTextWrapper>
          <StyledEmpValueContainer>
            <Typography
              width=''
              size='18px'
              margin='5px 0 0 0'
              color={
                auth.Value
                  ? DIGIPOSTHEME.colors.darkGrey
                  : DIGIPOSTHEME.colors.secondaryGraySecondary
              }
            >
              {auth.Value
                ? t && t("open").toString()
                : t && t("close").toString()}
            </Typography>
          </StyledEmpValueContainer>
        </StyledEmpOuterContainer>
      )}
    </Row>
  ));
};

export { AuthListItem };
